import { useState } from 'react';

export function useCpfFormat(initialValue = '') {
  const [cpf, setCpf] = useState(initialValue);


  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const formattedCpf = formatCpf(event.target.value);
    setCpf(formattedCpf);
  };

  return [cpf, handleChange] as const;
}

export const formatCpf = (text: string) => {
  // Remove todos os caracteres que não são dígitos
  let cleaned = text.replace(/\D/g, '');
  
  // Adiciona a formatação conforme o usuário digita
  let formattedCpf = '';
  if (cleaned.length > 0) {
    formattedCpf = cleaned.substring(0, 3);
  }
  if (cleaned.length > 3) {
    formattedCpf += '.' + cleaned.substring(3, 6);
  }
  if (cleaned.length > 6) {
    formattedCpf += '.' + cleaned.substring(6, 9);
  }
  if (cleaned.length > 9) {
    formattedCpf += '-' + cleaned.substring(9, 11);
  }

  return formattedCpf;
};